export default {
    credito: {
        solicitud: {
            tipo_direccion_select: 'Seleccione el tipo de dirección',
            municipio_select: 'Seleccione el municipio',
            tipo_referencia_select: 'Seleccione el tipo de referencia',
            tipo_parentesco_select: 'Seleccione el tipo de parentesco',
        }
    }
}